
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gFBsClGA6V0Hc5MgRbUH2M9lRAyrcIJmsMgLU4YZmo9oMeta } from "/codebuild/output/src13323320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexNKiwOhhnngTNrzWtbLkZCeVK1PU1eGVrqKfztdjPnjUMeta } from "/codebuild/output/src13323320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searcho4v6VhbsfKLWH91okMittXPeABh893AgHa8uOPSwExoMeta } from "/codebuild/output/src13323320/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexroHOybA_eTCUrdpn0mvI6xF2t7xUj8CLRvAp53wtw0gMeta } from "/codebuild/output/src13323320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93iFDiAotEQDvh1KOFXl7pn7mHeP_jRWiIsABT0Ch6ghsMeta } from "/codebuild/output/src13323320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexwbZldUbHQ69Qo5_x8Yu2OgLHuDT1zAOtvwpM3dWFqHAMeta } from "/codebuild/output/src13323320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93yFLBeG_45SvEBdCT_45J4B81N9cMlIvKQLzmwxi2mPw4xQQMeta } from "/codebuild/output/src13323320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexcdS26EYkbEk3KvDZFjnmYxduWOjiPUMcs19xm2TbDF0Meta } from "/codebuild/output/src13323320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_939NA7_rcdjmhnBNq42bfJ4a0cgHemDocMW5ka3nQ0TPgMeta } from "/codebuild/output/src13323320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexDgGwZojY08xDW_454rNZCAnktuzENmfkLuN6sA5b85WXAMeta } from "/codebuild/output/src13323320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexTS1Iohgj6Ljfu8X7gcN4iAJVbby9ZuVmhRJECsgHowUMeta } from "/codebuild/output/src13323320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src13323320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src13323320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src13323320/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src13323320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src13323320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexwbZldUbHQ69Qo5_x8Yu2OgLHuDT1zAOtvwpM3dWFqHAMeta || {},
    component: () => import("/codebuild/output/src13323320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src13323320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexcdS26EYkbEk3KvDZFjnmYxduWOjiPUMcs19xm2TbDF0Meta || {},
    component: () => import("/codebuild/output/src13323320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src13323320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexDgGwZojY08xDW_454rNZCAnktuzENmfkLuN6sA5b85WXAMeta || {},
    component: () => import("/codebuild/output/src13323320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexTS1Iohgj6Ljfu8X7gcN4iAJVbby9ZuVmhRJECsgHowUMeta || {},
    component: () => import("/codebuild/output/src13323320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]